import { z } from 'zod';
// Request contracts for the `shopping-lists` Edge Function. Kept dependency-free
// (zod only, no relative imports) so Deno can load this file directly.
/** Regeneration strategies — mirrors `utils/shopping-list.ts`. */
const REGENERATION_MODES = ['replace', 'update'];
/**
 * Generates a list from planned meals. When `list_id` is provided the existing
 * list is regenerated in place using `mode` (defaults to `update`).
 *
 * A list has no name: `shopping_lists` holds the days it covers and nothing
 * else, and the screen titles it « Liste de courses » all the same. The field
 * was required here and dropped by the handler, so a caller with nothing to
 * put in it — the courses screen, regenerating the list it is showing — sent
 * `undefined` and got a 400 for a name the server would have thrown away.
 */
export const GenerateListSchema = z.object({
    meal_ids: z.array(z.string().uuid()),
    list_id: z.string().uuid().optional(),
    mode: z.enum(REGENERATION_MODES).optional(),
});
export const AddRecipeSchema = z.object({
    recipe_id: z.string().uuid(),
});
export const AddItemSchema = z.object({
    name: z.string().min(1),
    quantity: z.number().positive().nullable().optional(),
    unit: z.string().nullable().optional(),
    category: z.string().optional(),
});
export const UpdateItemSchema = z.object({
    checked: z.boolean().optional(),
    quantity: z.number().positive().nullable().optional(),
    unit: z.string().nullable().optional(),
});
//# sourceMappingURL=shopping-list-requests.js.map